export function RenderDOMData(data) {
  let layerCompData = [],
    animationObj = [];

  let sample = [];

  let Id;
  data.forEach((data, index) => {
    // console.log(data.componentType, "sssssss");
    Id = data.componentType + index;
    let shapeType =
      data.components.textComponentType?.addContent === "triangleShape"
        ? "triImage"
        : data.components.textComponentType?.addContent === "polygonShape"
          ? "pentImage"
          : data.components.textComponentType?.addContent === "hexagonShape"
            ? "hexImage"
            : "";
    layerCompData.push({
      id: data.componentType + index,
      componentType: data.componentType,
      froalaText: data.components.froalaText,
      componentStyles: data.components,
      textComponentType: data.components.textComponentType,
      [shapeType]: data.components.src,
    });

    let animationObjectNew = JSON.parse(
      JSON.stringify(data.components.animationObj || []),
    );
    // Object.values(animationObjectNew.animation).forEach((obj) => {
    let obj = animationObjectNew.animation || [];
    // Commented out: do not add a default keyframe at 0s.
    // if (obj.length > 0 && obj[0].delay !== 0) {
    //   let tempObj = obj[0];
    //   if (tempObj) {
    //     tempObj.delay = 0;
    //
    //     tempObj.duration = tempObj?.end;
    //     let firstObject = {
    //       ...tempObj,
    //       rotation: 0,
    //       left: 0,
    //       top: 0,
    //       width: tempObj.width,
    //       height: tempObj.height,
    //       transform: 1,
    //       delay: 0,
    //       duration: 0,
    //       ease: "NONE",
    //       end: 0,
    //       opacity: 1,
    //     };
    //     obj.splice(0, 0, firstObject);
    //     obj[1] = tempObj;
    //   }
    // }
    // });

    obj.forEach((eachAnimation) => {
      const animationData = {
        api: "to",
        atoms: [Id],
        duration: eachAnimation.duration,
        op: {
          delay: eachAnimation.delay,
          opacity: eachAnimation.opacity,
          ease: eachAnimation.ease,
          rotation: eachAnimation.rotation,
          rotationX: eachAnimation.rotationX,
          rotationY: eachAnimation.rotationY,
          scale: eachAnimation.transform,
          left: 0,
          top: 0,
          transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
          width: eachAnimation?.width,
          height: eachAnimation?.height,
          transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
          backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
        },
      };
      animationObj.push(animationData);
    });
  });
  // setCanvasDom(layerCompData);
  // setAnimationObj(animationObj);

  return { layerCompData, animationObj };
  //console.log(layerCompData, "layerCompData", animationObj);
}
